import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LinkSummaryItem } from '../../../../../core/services/revamp.service';

@Component({
  selector: 'app-confirm-linked-records-dialog',
  templateUrl: './confirm-linked-records-dialog.component.html',
  styleUrls: ['./confirm-linked-records-dialog.component.scss'],
})
export class ConfirmLinkedRecordsDialogComponent {
  @Input() visible = false;
  @Input() title = 'Confirm delete';
  @Input() warning = '';
  @Input() links: LinkSummaryItem[] = [];
  @Input() confirmLabel = 'Delete';
  @Input() loading = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onHide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.cancelled.emit();
  }

  onConfirm(): void {
    this.confirmed.emit();
  }
}
